const en = {
  lang: {
    caption: "Language",
    aria: "Change site language, current: ",
  },
  a11y: {
    skipToMain: "Skip to main content",
  },
  nav: {
    home: "Home",
    services: "Services",
    portfolio: "Portfolio",
    about: "About",
    contact: "Contact",
    cta: "Message on WhatsApp",
  },
  hero: {
    offer: "Websites, chatbots and lead capture for your business",
    h1a: "A site or bot for bookings and requests — ",
    h1b: "built for your business",
    h2: "We set up inquiries, site forms and WhatsApp, Instagram and Telegram flows",
    ctaReview: "Get a free consultation",
    ctaContact: "Message on Telegram",
    imgAlt: "Broxe Group — websites and chatbots for business",
  },
  solution: {
    beforeBrand: "What ",
    afterBrand: " does: websites, bots and lead capture",
    lead:
      "We build and configure tools — pages, bots, flows. Revenue and sales depend on your offer and how you work with clients; we handle the technical side.",
    l1: "The site and bot follow the flow you approve: replies, booking, requests",
    l2: "Usually 3–7 days to a launch-ready setup — then you run the process",
    l3: "Bookings and requests in one chain — less manual back-and-forth in chats",
    ctaConsult: "Get a consultation",
    quote:
      "We don’t promise income. We deliver working bots, landing pages and integrations — how you use them is up to you.",
  },
  servicesPrev: {
    beforeH: "Tools ",
    highlight: "for business",
    afterH: ": site, bot, leads",
    intro:
      "Landing pages, chatbots, simple lead systems and niche flows — scoped to the task, nothing extra.",
    s1t: "Chatbots",
    s1d:
      "WhatsApp, Instagram, Telegram: scripted replies, booking, requests — while you’re busy.",
    s2t: "Leads & systems",
    s2d:
      "Capture from the site and messengers in one place — easier for you and staff.",
    s3t: "Websites",
    s3d:
      "Business landing pages: fast launch, clear copy, a request form.",
    s4t: "For your niche",
    s4d:
      "Clinics, detailing, salons, barbershops, auto shops — turnkey starter flows.",
    btn: "View services",
  },
  process: {
    beforeH: "Three steps — ",
    highlight: "from brief to launch",
    p1t: "Clarify the task",
    p1d:
      "How you take inquiries today — phone, chats, site — and what to automate first.",
    p2t: "Build and launch",
    p2d:
      "Site, bot or lead flow — usually 3–7 days to a usable version.",
    p3t: "Adjust if needed",
    p3d:
      "We tweak copy and flows from your feedback — until it’s comfortable for you and clients.",
  },
  ctaFinal: {
    title: "Let’s discuss your task",
    sub:
      "Free consultation or a short call: what we can connect and how we work — no revenue guarantees.",
    req: "Get a consultation",
    demo: "Message on Telegram",
  },
  social: {
    title: "Write to us — we’ll reply about services",
    or: "or",
    p2: ": city and industry — we’ll outline typical next steps in similar cases",
  },
  faq: {
    title: "Frequently asked questions",
    subtitle: "Sites, bots and leads — common questions",
    items: [
      {
        q: "How long does the first launch take?",
        a: "Usually 3–7 business days to a working setup: site, bot or lead capture. Then we adjust based on your feedback.",
      },
      {
        q: "Do I need to spend more on ads right away?",
        a: "Not necessarily. You can first handle people who already message you: replies, booking, a site form. Ads are a separate decision.",
      },
      {
        q: "Who is this for?",
        a: "Detailing, clinics, salons, barbershops, auto shops, local businesses, Instagram shops — if you need requests and booking from the web and messengers.",
      },
      {
        q: "Only WhatsApp and Telegram?",
        a: "No. WhatsApp, Instagram, Telegram — as agreed. We set it up so clients can request or book with minimal friction.",
      },
      {
        q: "How do we start?",
        a: "Send your niche, city and main channel (e.g. WhatsApp). Site buttons open messengers — you can ask for a consultation.",
      },
      {
        q: "How is pricing set?",
        a: "By scope: channels, whether you need a site, bot depth. Priced per task — no forced packages.",
      },
    ],
  },
  aboutPage: {
    h1a: "Who we are and ",
    h1b: "what we do",
    imgAlt: "Broxe Group — websites, chatbots and leads for business",
  },
  aboutCard: {
    p1rest:
      "delivers custom landing pages, chatbots on WhatsApp, Instagram and Telegram, simple lead systems and ready-made flows for salons, clinics, detailing, auto shops and social shops. The goal is a solid fit for the task — not slides for investors.",
    p2:
      "Sites and bots are tools: they let clients book or leave a request. How you handle those inquiries is on your side.",
    li1: "Clear tools — site, bot, leads — not vague “branding” talk",
    li2: "We configure replies and booking to your rules and schedule",
    li3: "Timelines in days, not quarters — we launch fast and iterate from feedback",
    quote: "We don’t replace your marketing — we ship working bots and pages.",
  },
  servicesPage: {
    h1a: "What we build ",
    h1b: "for business",
    p1:
      "We pick a stack for your brief: site, bot, forms, integrations — what you asked for.",
    p2:
      "Typical start is 3–7 days; exact timing after a short discussion.",
  },
  servicesDetail: {
    chatbot: {
      title: "Chatbots",
      bullets: [
        "WhatsApp, Instagram, Telegram — scripted replies, booking, requests",
        "Fewer repetitive manual messages — the bot follows steps",
        "One scenario per channel — easier to maintain",
      ],
    },
    automation: {
      title: "Leads & simple systems",
      bullets: [
        "Site and messenger requests in one place",
        "Sheet or light CRM — optional, no overload",
        "Less manual contact copying",
      ],
    },
    sites: {
      title: "Websites & landing pages",
      bullets: [
        "Landing with a clear action: message, call or request",
        "Fast launch — copy can change later",
        "Layout for mobile screens",
      ],
    },
    content: {
      title: "Niche solutions",
      bullets: [
        "Clinics, detailing, salons, barbershops, auto shops — starter templates for your format",
        "Pricing, address, services, booking — built from your list",
        "Then small updates for promos and changes",
      ],
    },
  },
  contact: {
    h1a: "Write to us — ",
    h1b: "let’s discuss the task",
    intro:
      "WhatsApp or Telegram — we reply and explain what we can set up. Direct links below.",
    waPrefillReview:
      "Hello! I’d like a free consultation on a site and leads for my business (Broxe Group).",
    waPrefillConsult:
      "Hello! I need a consultation: website, chatbot or leads for my business (Broxe Group).",
    waPrefillDemo:
      "Hello! I’d like to discuss a site or bot for my business (Broxe Group).",
    waPrefillNav: "Hello! I’d like to get in touch with Broxe Group.",
    tgPrefillContact:
      "Hello! Writing from the Broxe Group site — I’d like to discuss leads and a website.",
    tgPrefillDemo:
      "Hello! I’d like to discuss a site or bot for my business (Broxe Group).",
  },
  leadForm: {
    name: "Name",
    phone: "Phone or Telegram",
    phName: "How we should address you",
    phPhone: "+1 … or @username",
    alert:
      "Request received. We’ll message or call — we’ll clarify the task: site, bot or lead capture.",
    submitDefault: "Submit a request",
    submitConsult: "Get a consultation",
  },
  serviceCard: {
    demo: "Message on WhatsApp",
  },
  footer: {
    tagline:
      "Websites and chatbots scoped to your business. The tools are yours to run.",
    ariaWa: "Broxe Group on WhatsApp",
    ariaTg: "Broxe Group on Telegram",
  },
  homeAria: {
    wa: "Write to Broxe Group on WhatsApp",
    tg: "Write to Broxe Group on Telegram",
  },
  portfolio: {
    sectionTitle: "Selected work",
    sectionSubtitle: "Individual projects: UI, pages, and demo videos.",
    viewAll: "View all projects",
    pageTitle: "Portfolio — all projects",
    pageSubtitle:
      "Image galleries open in a new tab at full size; videos play inline. Files are served from the portfolio folder.",
    badgeGallery: "Screens",
    badgeVideo: "Video",
    copyLink: "Copy link",
    linkCopied: "Copied",
    items: {
      adminPanel: {
        title: "Admin panel",
        desc: "Management UI screenshots.",
      },
      lardiTrans: {
        title: "Lardi-Trans",
        desc: "Pages and flows.",
      },
      regemsal: {
        title: "Regemsal",
        desc: "Main screens for the project.",
      },
      tutAz: {
        title: "Tut.az",
        desc: "Home and product page.",
      },
      projectManager: {
        title: "Project manager",
        desc: "Product UI snippets.",
      },
      jsdelivr: {
        title: "jsDelivr stats",
        desc: "Network and statistics views.",
      },
      lg2: {
        title: "Project (lg2)",
        desc: "Home page variants.",
      },
      podriadchik: {
        title: "Contractor platform",
        desc: "Marketplace, companies, chat.",
      },
      apiBoost: {
        title: "API Boost",
        desc: "UI screens and flows.",
      },
      alivaria: {
        title: "Alivaria",
        desc: "Pages and UI details.",
      },
      belInter: {
        title: "Bel Inter",
        desc: "Interface highlights.",
      },
      bitcoinEmpire: {
        title: "Bitcoin Empire",
        desc: "App screens.",
      },
      tringleSpace: {
        title: "Tringle Space",
        desc: "Main UI screens.",
      },
      espireo: {
        title: "Espireo",
        desc: "Project screens.",
      },
      huskyHelp: {
        title: "Husky Help",
        desc: "Pages and user flows.",
      },
      presentashki: {
        title: "Presentashki",
        desc: "Screens and layouts.",
      },
      video: {
        desc: "Short project demo video.",
      },
      v0074: { title: "Auth System" },
      v0076: { title: "Standoff Duel" },
      v0081: { title: "A1 CRM" },
      v0082: { title: "Korpu" },
      v0083: { title: "Outlet Store" },
      v0088: { title: "Chat System" },
      v0089: { title: "T-Movies" },
      v0091: { title: "DND-Kanban" },
      v0092: { title: "Med Yu Med" },
      v0094: { title: "Payment System" },
      v0095: { title: "Chat System" },
    },
  },
  seo: {
    siteName: "Broxe Group",
    ogImageAlt: "Broxe Group — websites and chatbots for business",
    keywords:
      "landing page, business website, WhatsApp chatbot, Instagram chatbot, Telegram chatbot, lead forms, online booking, detailing, clinic, beauty salon, barbershop, auto shop, Instagram store",
    home: {
      title: "Broxe Group — websites and chatbots for business",
      description:
        "Landing pages, chatbots on WhatsApp, Instagram and Telegram, lead capture, niche solutions. Detailing, clinics, salons, local business. WhatsApp & Telegram.",
    },
    services: {
      title: "Broxe Group services — sites, chatbots, leads",
      description:
        "Chatbots for messengers, landing pages, simple lead systems, flows for salons, clinics, detailing and shops. We discuss the task and pick a format.",
    },
    about: {
      title: "About Broxe Group — sites and bots for small & local business",
      description:
        "Broxe Group: landing pages, bots, lead capture. Salons, clinics, detailing, auto shops, social shops.",
    },
    contact: {
      title: "Contact Broxe Group — WhatsApp & Telegram",
      description:
        "Reach Broxe Group on WhatsApp or Telegram — questions about sites, bots and leads.",
    },
    portfolio: {
      title: "Broxe Group portfolio — work samples & demo videos",
      description:
        "Work samples: interfaces, landing pages, demo videos. All on one page.",
    },
  },
};

export default en;
